import React from "react";
import ContractForms from "./ContractForms";

export default function EditContract() {
  return <ContractForms type="Edit" />;
}
